import { render, staticRenderFns } from "./TracksArtistsEditPanelDialog.vue?vue&type=template&id=ff9585aa"
import script from "./TracksArtistsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./TracksArtistsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports